/**
 * Removing a name rejects updates to schemas still holding it. Retire one by moving it to a
 * legacy set the resolver still maps, as `call-analysis-tag-icon-picker` does.
 */
export const SCHEMA_ICON_PICKER_OPTIONS = [
    { name: 'User', label: 'Person / individual' },
    { name: 'Users', label: 'Group / household / team' },
    { name: 'Contact', label: 'Contact record' },
    { name: 'Briefcase', label: 'Company / organization' },
    { name: 'Building2', label: 'Property / site / branch' },
    { name: 'Home', label: 'Residence' },
    { name: 'Store', label: 'Storefront / location' },
    { name: 'MapPin', label: 'Place / territory' },
    { name: 'ShoppingCart', label: 'Order / cart' },
    { name: 'Receipt', label: 'Invoice / charges' },
    { name: 'CreditCard', label: 'Payment method' },
    { name: 'DollarSign', label: 'Transaction / revenue' },
    { name: 'Package', label: 'Shipment / delivery' },
    { name: 'Box', label: 'Product / item' },
    { name: 'Truck', label: 'Fleet / logistics' },
    { name: 'Car', label: 'Vehicle' },
    { name: 'Calendar', label: 'Appointment / booking' },
    { name: 'Clock', label: 'Session / time entry' },
    { name: 'Ticket', label: 'Ticket / pass / event' },
    { name: 'Wrench', label: 'Job / service call' },
    { name: 'ClipboardList', label: 'Checklist / intake form' },
    { name: 'FileText', label: 'Document / contract' },
    { name: 'Mail', label: 'Email record' },
    { name: 'MessageSquare', label: 'Message / conversation' },
    { name: 'Phone', label: 'Call record' },
    { name: 'Bell', label: 'Notification / alert' },
    { name: 'Tag', label: 'Tag / label' },
    { name: 'Tags', label: 'Category set' },
    { name: 'Hash', label: 'Code / identifier' },
    { name: 'Flag', label: 'Flagged record' },
    { name: 'Star', label: 'Rating / VIP' },
    { name: 'Heart', label: 'Favorite / preference' },
    { name: 'Award', label: 'Loyalty / reward tier' },
    { name: 'Gift', label: 'Promotion / gift card' },
    { name: 'CircleCheck', label: 'Completion / status' },
    { name: 'Zap', label: 'Event / activity' },
    { name: 'Sparkles', label: 'Enrichment / derived record' },
    { name: 'Layers', label: 'Grouping / hierarchy' },
    { name: 'Database', label: 'External dataset' },
    { name: 'Dog', label: 'Pet / animal' },
];
/** Cast because `z.enum` needs a non-empty tuple. */
export const SCHEMA_ICON_PICKER_NAMES = SCHEMA_ICON_PICKER_OPTIONS.map(option => option.name);
/** Casing is tolerated for the render path only; the write enum requires the canonical name. */
export function resolveSchemaIconName(storedName) {
    const trimmed = storedName.trim();
    if (!trimmed)
        return null;
    const lower = trimmed.toLowerCase();
    let caseInsensitiveMatch = null;
    for (const name of SCHEMA_ICON_PICKER_NAMES) {
        if (name === trimmed)
            return name;
        if (caseInsensitiveMatch === null && name.toLowerCase() === lower) {
            caseInsensitiveMatch = name;
        }
    }
    return caseInsensitiveMatch;
}
//# sourceMappingURL=schema-icon-picker.js.map